//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    nombre: null,
  }),
  methods: {
    async submit() {
      const examen = await this.$store.dispatch("examen/add", this.$data)
      this.$emit("submit", examen)
    },
  },
}
